<template>
  <div :class='formGroupClass'>
    <label class='control-label'>{{ inputLabel }}</label>
    <input class='form-control' v-model="inputValue" :disabled="isView"/>
  </div>
</template>

<script>
import applicationInputMixin from '@/common/mixins/applicationInputMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin';
export default {
  name: 'DocumentNumberInput',

  mixins: [
    applicationInputMixin,
    applicationFormMixin
  ],

  props: {
    inputLabel: {
      type: String,
      default: 'Номер документа'
    },
    inputName: {
      type: String,
      default: 'number'
    }
  }
}
</script>
